import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const DatacentersPage = lazy(
  () => import('@/features/Datacenters/pages/DatacentersPage'),
)

export const Route = createFileRoute('/infra/datacenters')({
  beforeLoad: protectedRouteGuard,
  loader: () => ({
    crumb: 'Datacenters',
  }),
  component: () => (
    <Suspense fallback={<Loading />}>
      <DatacentersPage />
    </Suspense>
  ),
})
